import * as api from '../../api/funnel';
import { dashboardFunnelStepFilterActions } from '../../constants/filter';
import { asyncAction } from '../common';
import { errorHandlerUnitsQueries } from './dashboards';

export const selectFunnel = (funnel) => ({
  type: 'DASHBOARD_SELECT_FUNNEL',
  funnel,
});

export const setFunnelExposureError = (error) => ({
  type: 'DASHBOARD_SET_FUNNEL_EXPOSE_ERROR',
  error,
});

export const startUpdateFunnel = (funnel = null, unitId) => ({
  type: 'DASHBOARD_START_UPDATE_FUNNEL',
  funnel,
  unitId,
});

export const setFunnelName = (name, unitId) => ({
  type: 'DASHBOARD_UPDATE_SET_FUNNEL_NAME',
  name,
  unitId,
});

export const cancelUpdateFunnel = (unitId) => ({
  type: 'DASHBOARD_CANCEL_UPDATE_FUNNEL',
  unitId,
});

export const addFunnelStep = (unitId) => ({
  type: 'DASHBOARD_UPDATE_FUNNEL_ADD_STEP',
  unitId,
});

export const changeFunnelStepPosition = (oldIndex, newIndex, unitId) => ({
  type: 'DASHBOARD_UPDATE_FUNNEL_CHANGE_STEP_POSITION',
  oldIndex,
  newIndex,
  unitId,
});

export const setFunnelStepEventName = (stepIndex, event, unitId) => ({
  type: 'DASHBOARD_UPDATE_FUNNEL_SET_EVENT_NAME',
  stepIndex,
  event,
  unitId,
});

export const setFunnelStepLegendName = (stepIndex, name, unitId) => ({
  type: 'DASHBOARD_UPDATE_FUNNEL_SET_LEGEND_NAME',
  stepIndex,
  name,
  unitId,
});

export const toggleFunnelEnabled = (stepIndex, unitId) => ({
  type: 'DASHBOARD_UPDATE_TOGGLE_FUNNEL_ENABLED',
  stepIndex,
  unitId,
});

export const setFunnelStepOptionalStatus = (stepIndex, status, unitId) => ({
  type: 'DASHBOARD_UPDATE_FUNNEL_SET_STEP_OPTIONAL_STATUS',
  status,
  stepIndex,
  unitId,
});

export const setFunnelStepCount = (stepIndex, count, operator, unitId) => ({
  type: 'DASHBOARD_UPDATE_FUNNEL_SET_STEP_COUNT',
  count,
  operator,
  stepIndex,
  unitId,
});

export const setFunnelStepClosingRange = (stepIndex, closingRange, unitId) => ({
  type: 'DASHBOARD_UPDATE_FUNNEL_SET_STEP_CLOSING_RANGE',
  stepIndex,
  closingRange,
  unitId,
});

export const removeFunnelStep = (stepIndex, unitId) => ({
  type: 'DASHBOARD_UPDATE_REMOVE_FUNNEL_STEP',
  stepIndex,
  unitId,
});

export const setFunnelGlobalClosingRage = (closingRange, unitId) => ({
  type: 'DASHBOARD_UPDATE_FUNNEL_SET_GLOBAL_CLOSING_RANGE',
  closingRange,
  unitId,
});

export const addFilterClause = (stepIndex, unitId) => ({
  type: dashboardFunnelStepFilterActions.ADD_FILTER_CLAUSE,
  stepIndex,
  unitId,
});

export const removeFilterClause = (stepIndex, id, unitId) => ({
  type: dashboardFunnelStepFilterActions.REMOVE_FILTER_CLAUSE,
  id,
  stepIndex,
  unitId,
});

export const setFilterClauseField = (stepIndex, id, field, type, unitId) => ({
  type: dashboardFunnelStepFilterActions.SET_FILTER_CLAUSE_FIELD,
  id,
  field,
  stepIndex,
  fieldType: type,
  unitId,
});

export const setFilterClauseValue = (stepIndex, id, value, unitId) => ({
  type: dashboardFunnelStepFilterActions.SET_FILTER_CLAUSE_VALUE,
  id,
  value,
  stepIndex,
  unitId,
});

export const setClausesConcatOperator = (stepIndex, value, unitId) => ({
  type: dashboardFunnelStepFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  value,
  stepIndex,
  unitId,
});

export const setFilterClauseOperator = (stepIndex, id, value, resetClauseValue, unitId) => ({
  type: dashboardFunnelStepFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  id,
  value,
  resetClauseValue,
  stepIndex,
  unitId,
});

export const setFunnelFilterValue = (value, unitId) => ({
  type: 'DASHBOARD_FUNNEL_FILTER_VALUE_CHANGED',
  filterValue: value,
  unitId,
});

export const setFunnelSideListContainerWidth = (containerWidth, unitId) => ({
  type: 'DASHBOARD_SET_FUNNEL_SIDE_LIST_CONTAINER_WIDTH',
  containerWidth,
  unitId,
});

export const setConversionInterval = (conversionInterval, unitId) => ({
  type: 'DASHBOARD_SET_CONVERSION_INTERVAL',
  conversionInterval,
  unitId,
});

export const duplicateFunnel = (item, unitId) => ({
  type: 'DASHBOARD_FUNNEL_SELECT_DUPLICATE_FUNNEL',
  item,
  unitId,
});

export const changeFunnelView = (view, unitId) => ({
  type: 'DASHBOARD_CHANGE_FUNNEL_VIEW',
  view,
  unitId,
});

export const executeDashboardFunnel = (unit, executeId) =>
  asyncAction(
    'DASHBOARD_EXECUTE_FUNNEL',
    api.executeDashboardFunnelQuery(unit, executeId),
    errorHandlerUnitsQueries(unit.id)
  );
